import { cn } from '@1trading/react';

import { EnvDot } from '@/components/dashboard/env-meta';
import { ENVIRONMENTS, type Environment } from '@/types/catalog';

export type EnvFilterValue = Environment | 'all';

const ENV_LABEL: Record<Environment, string> = {
  dev: 'Dev',
  staging: 'Staging',
  preprod: 'Preprod',
  production: 'Production',
};

type EnvFilterProps = {
  value: EnvFilterValue;
  counts: Record<EnvFilterValue, number>;
  onChange: (value: EnvFilterValue) => void;
};

const pillClass = (isActive: boolean) =>
  cn(
    'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs transition-colors focus-visible:outline-2 focus-visible:outline-ring',
    isActive ? 'bg-primary font-medium text-primary-foreground' : 'text-muted-foreground hover:text-foreground',
  );

export const EnvFilter = ({ value, counts, onChange }: EnvFilterProps) => (
  <fieldset aria-label="Filter by environment" className="flex flex-wrap items-center gap-1 rounded-xl border bg-card p-1">
    <button type="button" onClick={() => onChange('all')} aria-pressed={value === 'all'} className={pillClass(value === 'all')}>
      All
      <span className={cn('text-[0.625rem]', value === 'all' ? 'text-primary-foreground/70' : 'text-muted-foreground/70')}>{counts.all}</span>
    </button>
    {ENVIRONMENTS.map((environment) => (
      <button key={environment} type="button" onClick={() => onChange(environment)} aria-pressed={value === environment} className={pillClass(value === environment)}>
        <EnvDot environment={environment} />
        {ENV_LABEL[environment]}
        <span className={cn('text-[0.625rem]', value === environment ? 'text-primary-foreground/70' : 'text-muted-foreground/70')}>{counts[environment]}</span>
      </button>
    ))}
  </fieldset>
);
